import { RouteObject } from "react-router";
import { Layout } from "../components";
import {
  LoginPage,
  BalancePage,
  SettingsPage,
  TransactionPage,
  Merchants,
  DocumentationPage,
} from "../pages";
import { ProtectedRoute } from "../components";
export const createAppRoutes = (
  isDark: boolean,
  setIsDark: React.Dispatch<React.SetStateAction<boolean>>
): RouteObject[] => [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <Layout isDark={isDark} setIsDark={setIsDark} />,
        children: [
          { path: "balance", element: <BalancePage /> },
          { path: "settings", element: <SettingsPage /> },
          { path: "rates", element: <Merchants /> },
          { path: "transactions", element: <TransactionPage /> },
          { path: "instructions", element: <DocumentationPage /> },
        ],
      },
    ],
  },
];
